// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export default class AnchorsEnum {
    static ELEMENT = '[data-element="anchors"]'
    static TRIGGER = '[data-trigger="anchor"]'
    static TRIGGER_REVEAL = '[data-trigger="anchors-reveal"]'
}
